import type React from 'react';
import { Controller } from 'react-hook-form';
import { Form, Input } from 'antd';
import type { FieldValues } from 'react-hook-form';
import type { RHFBaseProps, CommonChrome } from './types';
import { DEFAULT_FORM_LAYOUT } from './constants';

export type ControlledPasswordInputProps<TFieldValues extends FieldValues = FieldValues> =
  RHFBaseProps<TFieldValues> &
    CommonChrome &
    Omit<React.ComponentProps<typeof Input.Password>, 'value' | 'onChange' | 'onBlur'>;

export function ControlledPasswordInput<TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  label,
  required,
  disabled,
  help,
  layout,
  fieldClassName,
  ...rest
}: ControlledPasswordInputProps<TFieldValues>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange, onBlur }, fieldState }) => (
        <Form.Item
          label={label}
          required={required}
          validateStatus={fieldState.error ? 'error' : undefined}
          help={fieldState.error?.message ?? help}
          layout={layout ?? DEFAULT_FORM_LAYOUT}
          className={fieldClassName}
        >
          <Input.Password
            {...rest}
            value={value ?? ''}
            onChange={e => onChange(e.target.value)}
            onBlur={onBlur}
            disabled={disabled}
          />
        </Form.Item>
      )}
    />
  );
}
